<template>
  <section class="section reg">
    <div class="container reg__inner">
      <div class="reg__content">
        <span class="section__label">Документы</span>
        <h2 class="section__title">Положение о&nbsp;премировании — собирается автоматически</h2>
        <p class="section__subtitle reg__subtitle">
          Расчётные разделы система собирает сама из ваших формул, показателей и параметров.
          Вам остаётся дополнить вводные разделы и сохранить документ в PDF.
        </p>
        <ul class="reg__list">
          <li>Виды и размеры премий, показатели и порядок расчёта — прямо из ваших настроек</li>
          <li>Приложения с параметрами и шкалами коэффициентов формируются автоматически</li>
          <li>Изменили формулу — Положение обновилось, расхождений с расчётом нет</li>
          <li>Вводные разделы и подписант — заполняете сами, затем печать и сохранение в PDF</li>
        </ul>
      </div>
      <div class="reg__visual">
        <div class="reg__card">
          <div class="reg__card-title">Положение о премировании</div>
          <div class="reg__doc">
            <div class="reg__row">
              <span class="reg__row-name">1. Основные положения</span>
              <span class="reg__badge reg__badge--manual">вы заполняете</span>
            </div>
            <div class="reg__row">
              <span class="reg__row-name">2. Виды и размеры премий</span>
              <span class="reg__badge reg__badge--auto">авто</span>
            </div>
            <div class="reg__row">
              <span class="reg__row-name">3. Показатели премирования</span>
              <span class="reg__badge reg__badge--auto">авто</span>
            </div>
            <div class="reg__row">
              <span class="reg__row-name">4. Порядок расчёта (формулы)</span>
              <span class="reg__badge reg__badge--auto">авто</span>
            </div>
            <div class="reg__row">
              <span class="reg__row-name">5. Начисление, депремирование, споры</span>
              <span class="reg__badge reg__badge--manual">вы заполняете</span>
            </div>
            <div class="reg__row">
              <span class="reg__row-name">Приложения: параметры · шкалы</span>
              <span class="reg__badge reg__badge--auto">авто</span>
            </div>
          </div>
          <div class="reg__card-footer">
            <span class="reg__check">✓</span> Печать и сохранение в PDF
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'RegulationSection',
}
</script>

<style scoped>
.reg__inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}
.reg__subtitle { margin-bottom: 24px; }
.reg__list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.reg__list li {
  color: var(--gray);
  font-size: 0.9375rem;
  padding-left: 24px;
  position: relative;
  line-height: 1.6;
}
.reg__list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--secondary);
  font-weight: 700;
}
.reg__card {
  background: white;
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 28px 32px;
  box-shadow: var(--shadow);
}
.reg__card-title {
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--dark);
  margin-bottom: 20px;
  text-align: center;
}
.reg__doc {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.reg__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
}
.reg__row-name {
  font-size: 0.9375rem;
  color: var(--dark);
  font-weight: 500;
}
.reg__badge {
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
}
.reg__badge--auto {
  color: var(--secondary);
  background: rgba(16, 185, 129, 0.12);
}
.reg__badge--manual {
  color: var(--gray);
  background: var(--primary-light);
}
.reg__card-footer {
  border-top: 1px solid var(--border);
  margin-top: 20px;
  padding-top: 16px;
  font-size: 0.875rem;
  color: var(--gray);
  display: flex;
  align-items: center;
  gap: 8px;
}
.reg__check { color: var(--secondary); font-weight: 700; }

@media (max-width: 900px) {
  .reg__inner { grid-template-columns: 1fr; gap: 40px; }
}
</style>
